/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgStarOutline24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M11.991 2.018a.01.01 0 01.018 0l3.079 6.237a.01.01 0 00.007.006l6.885 1a.01.01 0 01.005.017l-4.981 4.856a.01.01 0 00-.003.01L18.177 21a.01.01 0 01-.015.01l-6.157-3.236a.01.01 0 00-.01 0l-6.157 3.237A.01.01 0 015.823 21L7 14.143a.01.01 0 00-.003-.009L2.015 9.278a.01.01 0 01.005-.017l6.885-1a.01.01 0 00.007-.006l3.079-6.237z'
      />
    </svg>
  );
}

export default SvgStarOutline24;
